var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePay = function SvgGooglePay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 33,
    fill: "none",
    viewBox: "0 0 35 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D9D9D9",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C4043",
    fillRule: "evenodd",
    d: "M16.53 15.758v-3.02h1.559c.639 0 1.178-.215 1.618-.637l.105-.107a2.175 2.175 0 0 0-.105-3.045 2.225 2.225 0 0 0-1.618-.648h-2.503v7.457h.944Zm0-3.936V9.217h1.583c.34 0 .662.13.902.369.51.5.522 1.332.03 1.85-.24.255-.58.398-.932.386H16.53Zm7.684-.767c-.404-.375-.955-.565-1.653-.565-.897 0-1.57.333-2.016.993l.832.529c.305-.452.721-.678 1.249-.678.334 0 .656.125.908.35.246.215.387.524.387.851v.22c-.363-.202-.82-.309-1.383-.309-.657 0-1.184.155-1.577.47-.393.315-.592.731-.592 1.26-.012.482.193.94.557 1.25.37.332.838.499 1.389.499.65 0 1.166-.291 1.56-.874h.04v.707h.903v-3.145c0-.66-.2-1.184-.604-1.558Zm-2.561 3.764a.776.776 0 0 1-.31-.625c0-.28.128-.511.38-.695.258-.185.58-.28.962-.28.527-.006.938.113 1.23.351 0 .404-.157.755-.468 1.053a1.489 1.489 0 0 1-1.061.446 1.142 1.142 0 0 1-.733-.25ZM26.846 18 30 10.656h-1.026l-1.46 3.663h-.017l-1.495-3.663h-1.026l2.07 4.775-1.173 2.57h.973Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M13.272 12.083c0-.291-.023-.583-.07-.868h-3.98v1.647h2.28a1.985 1.985 0 0 1-.844 1.302v1.07h1.36c.797-.742 1.254-1.843 1.254-3.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M9.222 16.27c1.137 0 2.098-.381 2.796-1.035l-1.36-1.07c-.38.261-.867.41-1.436.41-1.102 0-2.034-.755-2.368-1.766h-1.4v1.106a4.21 4.21 0 0 0 3.768 2.355Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M6.854 12.809a2.619 2.619 0 0 1 0-1.641v-1.1H5.453a4.3 4.3 0 0 0 0 3.841l1.401-1.1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M9.222 9.401a2.254 2.254 0 0 1 1.618.642l1.207-1.225a4.042 4.042 0 0 0-2.825-1.112 4.215 4.215 0 0 0-3.769 2.361l1.401 1.106c.334-1.017 1.266-1.772 2.368-1.772Z"
  })));
};
export default SvgGooglePay;